/**
 * Documentation KFP API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CreatePlannerRequest } from '../model/models';
import { PlannerResource } from '../model/models';
import { UpdatePlannerRequest } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface PlannerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Saves new planner to database
     * 
     * @param createPlannerRequest 
     */
    createNewPlanner(createPlannerRequest?: CreatePlannerRequest, extraHttpRequestParams?: any): Observable<PlannerResource>;

    /**
     * Deletes planner with given by ID
     * 
     * @param id 
     */
    deletePlanner(id: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Find event planners by given ID
     * 
     * @param id 
     */
    getEventPlannersById(id: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Updates an existing planner
     * 
     * @param id 
     * @param updatePlannerRequest 
     */
    updatePlanner(id: string, updatePlannerRequest?: UpdatePlannerRequest, extraHttpRequestParams?: any): Observable<PlannerResource>;

}
